
import { createContext, useContext, onMount } from "solid-js";
import { createStore, SetStoreFunction } from "solid-js/store";
import socket from "./socket";

const defaultStore = {
  users: [] as { id: number; username: string; email: string; role: string; userType: 'cas-user' | 'external-student', roleInput: string, emailInput: string, editing: boolean }[],
  results: false,
  resultsFetching: false
};

type AdminActions = {
  editUser: (index: number) => void;
  deleteUser: (user_id: number) => void;
  addUser: (fields: { username: string; email: string; role: string; userType: 'cas-user' | 'external-student' }) => void;
};

const AdminContext = createContext<
  [typeof defaultStore, SetStoreFunction<typeof defaultStore>, AdminActions]
>();

export function AdminContextProvider(props: {children: any}) {
  const [adminStore, setAdminStore] = createStore(defaultStore);

  
  onMount(() => {
    console.log('Mounted AdminContext');
    socket.on("user-list", (users) => {
      setAdminStore({users});
    });

    socket.on('results', (results) => {
        setAdminStore({results, resultsFetching: false});
    });

    socket.on('user-operation-error', (data: { error?: string }) => {
      alert(data.error || 'User operation failed');
    });

  });

  const actions = {
    editUser: (index: number) => {
      const user = adminStore.users[index];
      const fields = {
        role: user.roleInput,
        email: user.emailInput
      };
      socket.emit('update-user', {id: user.id, fields});
      setAdminStore('users', index, 'editing', false);
    },
    deleteUser: (user_id: number) => {
      socket.emit('delete-user', user_id);
      setAdminStore('users', (u) => u.filter((user) => user.id !== user_id));
    },
    addUser: (fields: { username: string; email: string; role: string; userType: 'cas-user' | 'external-student' }) => {
      socket.emit('add-user', fields);
    }
  }

  return (
    <AdminContext.Provider value={[adminStore, setAdminStore, actions]}>
      {props.children}
    </AdminContext.Provider>
  );
}

export function useAdminContext() { return useContext(AdminContext); }
